import { Link, NavLink } from "react-router-dom";
import { Btn } from "../ui/Btn/Btn";
import { Icon } from "../ui/Icon/Icon";
import styles from "./MarketingNav.module.css";

export function MarketingNav() {
  return (
    <header className={styles.nav}>
      <div className={styles.inner}>
        <Link to="/" className={styles.brand} aria-label="Notamen home">
          <span className={styles.mark}>✻</span>
          <span className={styles.brandText}>
            <span className={styles.brandName}>Notamen</span>
            <span className={styles.brandBy}>by phoenix apps</span>
          </span>
        </Link>

        <nav className={styles.links} aria-label="Primary">
          <a href="/#how-it-works" className={styles.link}>
            How it works
          </a>
          <a href="/#brand-kinds" className={styles.link}>
            For brands
          </a>
          <NavLink
            to="/pricing"
            className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ""}`}
          >
            Pricing
          </NavLink>
          <NavLink
            to="/docs"
            className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ""}`}
          >
            Docs
          </NavLink>
          <NavLink
            to="/changelog"
            className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ""}`}
          >
            Changelog
          </NavLink>
        </nav>

        <div className={styles.actions}>
          <Btn href="/signin" variant="ghost" size="sm">
            Sign in
          </Btn>
          <Btn href="/signup" variant="primary" size="sm" iconRight={<Icon name="arrow-right" size={14} />}>
            Join the waitlist
          </Btn>
        </div>
      </div>
    </header>
  );
}
